module.exports = __webpack_public_path__ + "../resources/images/illustration_access_error-03b49b544c5282a3df86d5d238d977a0.svg";